import { render, staticRenderFns } from "./DateView.vue?vue&type=template&id=c24c6fa0&scoped=true&"
import script from "./DateView.vue?vue&type=script&lang=js&"
export * from "./DateView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c24c6fa0",
  null
  
)

export default component.exports